export const adultingMedia = {
  xs: { maxWidth: 520 },
  sm: { maxWidth: 768 },
  md: { maxWidth: 1024 },
  lg: { maxWidth: 1280 },
  gtSm: { minWidth: 769 },
  gtMd: { minWidth: 1025 },
  hover: { hover: 'hover' },
  pointerCoarse: { pointer: 'coarse' },
} as const;
